import { Button } from '@mantine/core';
import { IconSparkles } from '@tabler/icons-react';

export interface NoteAiToolbarProps {
  canGenerate: boolean;
  /** A draft already exists — reopening Freud continues that note's conversation. */
  hasDraft?: boolean;
  generateLoading?: boolean;
  geminiAiDisabled?: boolean;
  outcomeTemplateAiDisabled?: boolean;
  disabled?: boolean;
  /** Starts the Freud progress-note flow (does not call generation directly). */
  onGenerateClick: () => void;
}

/**
 * Generate Note control for the progress note header. Generation itself runs inside the
 * Freud drawer after `onGenerateClick`; transcript status lives beside the note title.
 */
export function NoteAiToolbar({
  canGenerate,
  hasDraft = false,
  generateLoading = false,
  geminiAiDisabled = false,
  outcomeTemplateAiDisabled = false,
  disabled = false,
  onGenerateClick,
}: NoteAiToolbarProps): JSX.Element | null {
  if (geminiAiDisabled || outcomeTemplateAiDisabled || disabled) {
    return null;
  }

  return (
    <Button
      variant="default"
      leftSection={<IconSparkles size={14} />}
      loading={generateLoading}
      disabled={!canGenerate || generateLoading}
      onClick={onGenerateClick}
    >
      {hasDraft ? 'Edit Note' : 'Generate Note'}
    </Button>
  );
}
